"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.factory = type_guard_1.assertFunction([
    type_guard_1.props({
        prefix: type_guard_1.string(),
        settings: type_guard_1.record(type_guard_1.string(), type_guard_1.type()),
        component: type_guard_1.func()
    })
], function (args) {
    var _a;
    var prefix = args.prefix, settings = args.settings, component = args.component;
    var componentFactory = type_guard_1.assertFunction([type_guard_1.string(), type_guard_1.props(settings), type_guard_1.record(type_guard_1.string(), type_guard_1.record(type_guard_1.string(), type_guard_1.func()))], function (displayName, variantSettings, utils) {
        var componentVariant = component(variantSettings, utils, displayName);
        componentVariant.displayName = displayName;
        return componentVariant;
    }, { name: prefix });
    Object.defineProperty(componentFactory, 'name', {
        value: prefix,
        writable: false
    });
    var factoryName = "Factory" + prefix;
    return _a = {},
        _a[factoryName] = componentFactory,
        _a;
});
